// src/index.js
import React from "react";
import ReactDOM from "react-dom";
import { ChakraProvider } from "@chakra-ui/react";
import App from "./App";
// index.js 또는 App.js
import "./index.css";
import "./content/public-content.css";
import { applyMetadata, routeMetadata } from "./seo/metadata";

// Set route metadata before rendering, including direct visits to functional pages.
applyMetadata(routeMetadata(window.location.pathname));

ReactDOM.render(
  <ChakraProvider>
    <App />
  </ChakraProvider>,
  document.getElementById("root")
);
